<template>
	<div class="d-flex align-items-center min-vh-100 overflow-hidden">
		<div class="container">
			<div class="row">
				<div class="col-md-6 offset-md-3">
					<div class="animate__animated animate__fadeIn">
						<div class="card">
							<div class="card-body text-center">
								<h1>404</h1>
								<h3>Страница не существует</h3>
								<router-link :to="{path: '/'}" class="btn btn-lg btn-primary mt-3">На главную</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="css">

</style>

<script>
import lib from '@/lib';
import { useMeta } from 'vue-meta';

export default {
	mixins: lib.mixins,
	setup(){
		useMeta({title: 'Страница не найдена | TankOn2'});
	},
	mounted(){
		window.scrollTo(0, 0);
	},
	beforeRouteUpdate(to, from, next){
		//window.scrollTo(0, 0);
		next();
	},
};
</script>